import { EventRepository } from '~repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';
import { IProductImpressions } from '~interfaces/IAnalytics';

export class ProductImpressionsUseCase {
    private eventRepository: EventRepository;
    private productImpressionsPayload: IProductImpressions;

    constructor(productImpressionsPayload: IProductImpressions) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        const { gridSource = 'view_item_list', ...restPayload } = productImpressionsPayload;
        this.productImpressionsPayload = {
            ...restPayload,
            gridSource
        };
    }

    public execute = async () => {
        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.ANALYTICS_PRODUCTS_VIEWED,
            type: 'link',
            payload: {
                event_name: 'product_impression',
                event_category: 'ecommerce',
                event_action: 'view_item_list',
                event_label: this.productImpressionsPayload?.gridSource,
                event_noninteraction: true
            },
            data: {
                productImpressions: this.productImpressionsPayload
            }
        });
        this.eventRepository.addEventToQueue(newEvent);
    };
}
